"use strict";
/*
 * Created on 04 12 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValueWithUnitConverter_1 = require("../../core/conversions/ValueWithUnitConverter");

var SelloutReleaseItemSupply_1 = require("../model/sellout/SelloutReleaseItemSupply");

var SelloutReleaseItemSupplyConverter_1 = require("./SelloutReleaseItemSupplyConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutReleaseItemSupplyConverterImpl =
/*#__PURE__*/
function (_SelloutReleaseItemSu) {
  _inherits(SelloutReleaseItemSupplyConverterImpl, _SelloutReleaseItemSu);

  function SelloutReleaseItemSupplyConverterImpl() {
    _classCallCheck(this, SelloutReleaseItemSupplyConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemSupplyConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutReleaseItemSupplyConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        releaseItemId: conversions.toDocumentReferenceId(source.releaseItemId),
        date: conversions.fromDate(source.date),
        availableSupply: conversions.asObject(source, 'availableSupply', ValueWithUnitConverter_1.ValueWithUnitConverter.serialize(conversions)),
        amount: conversions.asObjectOpt(source, 'amount', ValueWithUnitConverter_1.ValueWithUnitConverter.serialize(conversions))
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutReleaseItemSupply_1.SelloutReleaseItemSupply(conversions.documentToClassId(source), conversions.asObject(source, 'releaseItemId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.toDate(source.date), conversions.asObject(source, 'availableSupply', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions)), conversions.asObjectOpt(source, 'amount', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions)));
    }
  }]);

  return SelloutReleaseItemSupplyConverterImpl;
}(SelloutReleaseItemSupplyConverter_1.SelloutReleaseItemSupplyConverter);

exports.SelloutReleaseItemSupplyConverterImpl = SelloutReleaseItemSupplyConverterImpl;